var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowVerify)?_c('div',[_c('email-status',{class:_vm.$style.widget,attrs:{"type":_vm.EmailType.LOGIN}}),_vm._v(" "),_c('email-status',{class:_vm.$style.widget,attrs:{"type":_vm.EmailType.NOTIFICATION}}),_vm._v(" "),(_vm.showDelimiter)?_c('div',{class:_vm.$style.delimiter}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }